// import { EnumModalPosition, EnumToastVariant } from "../../lib";
// import { EnumModalPosition } from "../../store/slices/modalSlice";

import { EnumModalPosition } from "../../libs/enums/EnumModalPosition";
import { EnumToastVariant } from "../../libs/enums/EnumToastVariant";

export interface IToastData {
    title?: string;
    message: string;
    customClass: string;
    position: EnumModalPosition | EnumModalPosition[],
    variant: EnumToastVariant,
}

export interface IInvoiceDownloadModalData {
    // selectedInvoice?:ApiSchemaInvoice;
    startDate?:string;
    endDate?:string;
    handleDownload?:(yearMonth:Date, isPatientReport?: boolean)=>void;
    OkButtonText?:string;
}

export interface ICommonModalData {
    headerText?:string;
    body:JSX.Element;
}

export interface IShowMoreModalData {
    list:string[];
}

export class ModalDataInitial {

    static readonly AppToast: IToastData = Object.freeze({
        message: "Successful",
        customClass: "bg-success",
        position: EnumModalPosition.Bottom,
        variant: EnumToastVariant.Success,
    })

    static readonly InvoiceDownloadModal: IInvoiceDownloadModalData = {        
        
     }

    static readonly CommonModal: ICommonModalData = {                
        body: null!
    }
    //  static readonly ShowMoreModal:IShowMoreModalData = {
    //      list:[]
    //  }

    //  static readonly ErrorModal:IErrorModal = {
    //     error:"",
    //  }

    //  static readonly ConfirmationModal:IConfirmationModal = {
    //     handleYes:()=>{},
    //  }
}

export class ModalData {
    // static AppToast = ModalDataInitial.AppToast;
    static InvoiceDownloadModal = ModalDataInitial.InvoiceDownloadModal;
    static CommonModal = ModalDataInitial.CommonModal;
    // static ShowMoreModal = ModalDataInitial.ShowMoreModal;
    // static ErrorModal = ModalDataInitial.ErrorModal;
    // static ConfirmationModal = ModalDataInitial.ConfirmationModal;
}